import React, { useImperativeHandle, forwardRef, useRef, useEffect, useState } from 'react';
import TapIcon from '../../services/TapIcon';
import { DisplayListPagination, DisplaySearchCriteria } from '../../components/TapUi';
import { IAM_API_BASE_URL_2 } from '../../services/TapApiUrls';
import ApplicationLayout from '../../layouts/ApplicationLayout';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../services/HttpAPICall';
import Loader from '../../components/ui/Loader/Loader';
import DateService from '../../services/DateService';
import api from '../../services/api';
import { toast } from 'react-toastify';
import download from '../../services/DownloadFile';
import swal from 'sweetalert';
import TapHelper from '../../services/TapHelper';
import PaymentDataDetail from './PaymentDataDetail';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const PaymentList = forwardRef((props, ref) => {
    const searchpaymentModalRef = useRef(null);
    const criteriaRef = useRef();
    const access_token = useSelector(state => state.auth.access_token);
    let listUrl = IAM_API_BASE_URL_2 + "/payment/list";
    let detailUrl = IAM_API_BASE_URL_2 + "/payment/detail"



    let initListData = {
        minimizeTable: false,
        items: [],
        meta: null,
        loading: false,
        page: 1,
        per_page: 50
    };

    const [downloadLoading, setDownloadLoading] = useState(false);
    const [formSearchedElems, setFormSearchedElems] = useState([]);
    const [submittedSearchForm, setSubmittedSearchForm] = useState({});
    const [itemData, setItemData] = useState({ ...initListData });
    const [criteriaHeight, setCriteriaHeight] = useState(0);
    const [selectedPaymentId, setSelectedPaymentId] = useState(null);
    const [selectedPayment, setSelectedPayment] = useState(null);

    const updateCriteriaHeight = () => {
        if (criteriaRef.current) {
            const height = criteriaRef.current.offsetHeight;
            if (criteriaHeight !== height) {
                setCriteriaHeight(height);
            }
        }
    };

    useEffect(() => {
        updateCriteriaHeight();
        loadListData(1);
    }, [submittedSearchForm]);

    const viewModalInit = (paymentId) => {
        setItemData(pd => ({ ...pd, minimizeTable: true }));
        const selectedItem = itemData.items.find(item => item.id === paymentId);
        if (selectedItem) {
            setSelectedPayment(selectedItem.transaction_id);
        }
        setSelectedPaymentId(paymentId);

    };

    const loadListData = async (page = 1, searchParams = null) => {
        setItemData(pd => ({ ...pd, loading: true, page: page }));
        try {
            const headers = { 'Authorization': 'Bearer ' + access_token };
            let params = {
                page: page
            };
            const response = await api.server2Api.get(listUrl, {
                params, headers
            });
            let respData = response.data;

            let meta = {
                from: respData.from,
                to: respData.to,
                total: respData.total,
                last_page: respData.last_page,
                per_page: respData.per_page,
                current_page: respData.current_page
            };

            setItemData(pd => ({
                ...pd,
                items: respData.data || [],
                meta: meta,
                loading: false
            }));
        } catch (error) {
            toast.error('Failed to load Payment Listing');
            setItemData(pd => ({ ...pd, loading: false }));
        }
    };

    const searchHandle = (element, data) => {
        setFormSearchedElems(element);
        setSubmittedSearchForm(data);
    };

    const employeeSearchClear = () => {
        setSubmittedSearchForm({});
        setFormSearchedElems([]);
        if (searchpaymentModalRef.current && searchpaymentModalRef.current.resetModalFilters) {
            searchpaymentModalRef.current.resetModalFilters();
        }
    };

    const searchModalHandle = () => {
        if (searchpaymentModalRef.current) {
            searchpaymentModalRef.current.initModalHandler();
        }
    };

    const paymentDownloadHandler = () => {
        let params = { action: "download", ...submittedSearchForm }

        const hasDateFilter = submittedSearchForm.date_range ||
            submittedSearchForm.start_date ||
            submittedSearchForm.end_date;

        if (!hasDateFilter) {
            swal({
                title: "Download",
                text: "The download will be for Current Month's Transaction, in case you want different Transaction Period then please change by filter.",
                icon: "warning",
                buttons: ["Cancel", "Okay"],
            }).then(willDownload => {
                if (willDownload) {
                    params = { ...params, date_range: "current_month" }
                    downloadHandler(params)
                }
            });
        } else {
            downloadHandler(params);
        }
    }

    const downloadHandler = (params) => {
        setDownloadLoading(true);
        HttpAPICall.withAthorization('GET', listUrl, access_token, params, {}, (response) => {
            download.file(response.data.file_path);
        }).finally(() => setDownloadLoading(false));
    };

    const paymentPdfDownloadHandler = () => {
        setDownloadLoading(true);
        HttpAPICall.withAthorization('GET', detailUrl + "/" + selectedPaymentId, access_token,
            { action: "download" }, {},
            (response) => {
                download.file(response.data.file_path);
            }
        ).finally(() => setDownloadLoading(false));
    };


    const viewPaymentDetail = (paymentId) => {
        setItemData(pd => ({ ...pd, minimizeTable: true }));
        const selectedItem = itemData.items.find(item => item.transaction_id === paymentId);
        if (selectedItem) {
            setSelectedPayment(selectedItem.transaction_id);
        }
        setSelectedPaymentId(paymentId);
    };

    const closePaymentDetail = () => {
        setSelectedPaymentId(null);
        setItemData(pd => ({ ...pd, minimizeTable: false }));
         props.history.push("/payment_list");
    };


    const getPaymentTypeDisplay = (paymentType) => {
        return paymentType === 'NULL' ? '-' : paymentType;
    };

    const headerJsx = () => {
        return (
            <>
                <Helmet>
                    <title>{itemData.minimizeTable ? 'Payment Detail' : 'Payment List'}</title>
                </Helmet>
                <div className="page_title m0 row">
                    <div className='col-sm-12'>
                        <div className='row'>
                            {!itemData.minimizeTable ? (
                                <>
                                    <div className='col-sm-6'>
                                        <h3 className='mb-0'>Payment List</h3>
                                    </div>
                                    <div className='col-sm-6'>
                                        <div className='text-end d-flex gap-2 align-items-center justify-content-end mt15'>
                                            {/* <button type="button" className="btn btn-secondary" disabled={itemData.loading} onClick={searchModalHandle}>
                                                <TapIcon.imageIcon icon={TapIcon.SearchIcon} />
                                            </button> */}
                                            <button type="button" className="btn btn-secondary"
                                                disabled={downloadLoading || itemData.loading}
                                                onClick={paymentDownloadHandler}>
                                                <TapIcon.FontAwesomeIcon icon={TapIcon.faDownload} />
                                                {downloadLoading ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : ''}
                                            </button>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className='col-sm-3'>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <h3>Payment</h3>
                                        </div>
                                    </div>
                                    <div className='col-sm-9 tap_border_left'>
                                        <h3 className='mb-0'>Payment Detail : {selectedPayment}</h3>
                                        <div className='text-end d-flex align-items-center justify-content-end mt15'>
                                            <button type="button" className="btn btn-secondary"
                                                disabled={downloadLoading || itemData.loading}
                                                onClick={paymentPdfDownloadHandler}>
                                                <TapIcon.FontAwesomeIcon icon={TapIcon.faDownload} />
                                                {downloadLoading ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : ''}
                                            </button>
                                            <button type="button" className="btn btn-secondary" onClick={closePaymentDetail}>
                                                <TapIcon.imageIcon icon={TapIcon.CloseIcon} />
                                            </button>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </>
        );
    };

    const PaymentListJsx = () => {
        return (
            <>
                <div
                    ref={criteriaRef}
                    style={{
                        position: 'sticky',
                        top: 0,
                        background: 'white',
                    }}
                >
                    <DisplaySearchCriteria searchedElems={formSearchedElems}
                        onClearFilter={employeeSearchClear}
                    />
                </div>

                <table className="table table-bordered align-middle bg-white">
                    <thead className="align-middle table-secondary" style={{
                        top: `${criteriaHeight}px`,
                        position: 'sticky',
                    }}>
                        {itemData.minimizeTable ? (
                            <tr className='text-center'>
                                <th scope="col">Payment</th>
                            </tr>
                        ) : (
                            <tr className='text-center'>
                                <th style={{ width: "5%" }}>S.No</th>
                                <th style={{ width: "12%" }}>Transaction ID</th>
                                <th style={{ width: "12%" }}>Transaction Date</th>
                                <th style={{ width: "10%" }}>Wallet</th>
                                <th style={{ width: "12%" }}>Payment Mode</th>
                                <th style={{ width: "12%" }}>Payment Amount</th>
                                <th style={{ width: "12%" }}>Balance Amount</th>
                                <th style={{ width: "10%" }}>Action</th>
                            </tr>
                        )}
                    </thead>
                    <tbody>
                        {itemData.loading ? (
                            <tr>
                                <td className='text-center' colSpan={itemData.minimizeTable ? 1 : 9}>
                                    <Loader />
                                </td>
                            </tr>
                        ) : (
                            itemData.items && itemData.items.length > 0 ? (
                                itemData.items.map((item, index) => {
                                    if (itemData.minimizeTable) {
                                        return (
                                            <tr key={item.id} className={selectedPaymentId === item.id ? 'bg-light' : ''}>
                                                <td className='text-start'>
                                                    <Link to={{ pathname: "/payment_list/" + item.transaction_id }}
                                                        onClick={() => viewPaymentDetail(item.transaction_id)}>
                                                        <div className="text-capitalize link-primary cursor_pointer">
                                                            {item.transaction_id || "-"}
                                                        </div>
                                                    </Link>
                                                    <div className="mt-1">
                                                        <span className="text-xs ">
                                                            {DateService.dateFormat(item.transaction_date)}</span>
                                                        <span className="float-end text-xs">{item.payment_mode || '-'}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    } else {
                                        return (
                                            <tr key={item.id}>
                                                <td className='text-center'>{(itemData.meta?.from || 1) + index}</td>
                                                <td className='link-primary cursor_pointer'>
                                                    <Link to={{ pathname: "/payment_list/" + item.transaction_id }}
                                                        onClick={() => viewPaymentDetail(item.transaction_id)}>
                                                        {item.transaction_id || "-"}
                                                    </Link>
                                                </td>
                                                <td className='text-center'>{DateService.dateFormat(item.transaction_date)}</td>
                                                <td className='text-center'>
                                                    {item.wallet?.wallet_name || '-'}
                                                    {item.wallet?.acc_num && <small className="d-block text-muted">Acc: {item.wallet.acc_num}</small>}
                                                </td>
                                                <td className='text-center'>{item.payment_mode || '-'}</td>
                                                <td className='text-center'>₹{item.payment_amount || '0.00'}</td>
                                                <td className='text-center'>₹{item.balance_amount || '0.00'}</td>
                                                <td className="text-center">
                                                    <TapIcon.imageIcon icon={TapIcon.ListActionIcon} alt="action-icon" className="img-fluid pr10 pl10" data-bs-toggle="dropdown" href="#"
                                                        role="button" aria-expanded="false" />
                                                    <ul className="dropdown-menu" style={{ cursor: "pointer" }}>
                                                        <Link to={{ pathname: "/payment_list/" + item.transaction_id }}
                                                            className="dropdown-item" role="button"
                                                            onClick={() => viewModalInit(item.transaction_id)}>
                                                            View
                                                        </Link>
                                                    </ul>
                                                </td>
                                            </tr>
                                        );
                                    }
                                })
                            ) : (
                                <tr>
                                    <td className='text-center' colSpan={itemData.minimizeTable ? 1 : 10}>
                                        No Record Found
                                    </td>
                                </tr>
                            )
                        )}
                    </tbody>
                </table>
                <DisplayListPagination meta={itemData.meta} onPageChange={(e) => loadListData(e.selected + 1)} />
            </>
        );
    };

    return (
        <>
            <ApplicationLayout>
                {/* <PaymentSearchModal
                    ref={searchpaymentModalRef}
                    searchHandle={(element, searchData) => searchHandle(element, searchData)}
                    listingLoading={itemData.loading}
                    formSearchedElems={formSearchedElems}
                    appliedSearchData={submittedSearchForm}
                /> */}
                {headerJsx()}
                <div className="container-fluid pl5">
                    <div className='page_containt row'>
                        <div className={["pageTbl", itemData.minimizeTable ? "col-3" : "col-12"].join(" ")}>
                            {PaymentListJsx()}
                        </div>
                        {itemData.minimizeTable && selectedPaymentId && (
                            <div className="col-9 pr4 pl4 bg-white pageTbl">
                                <div className="tab_content_header">
                                    <PaymentDataDetail
                                        paymentId={selectedPaymentId}
                                        onClose={closePaymentDetail}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </ApplicationLayout>
        </>
    );
});

export default PaymentList;